// import React, { useState, useEffect } from "react";
// import apiService from "../../Common/Configurations/APIService";
// import config from "../../Common/Configurations/APIConfig";
// import { useAuth } from "../../Common/Configurations/AuthContext";
// import moment from "moment";
// import SupplierPaymentModal from "./SupplierPaymentModal";
// import Header from "../../Common/Layout/Header";
// import AccountTabs from "../AllTabs/AccountTabs";

// const SupplierLedger = () => {
//   const { user } = useAuth();
//   const [statement, setStatement] = useState(null);
//   const [suppliers, setSuppliers] = useState([]);
//   const [selectedRefId, setSelectedRefId] = useState("");
//   const [fromDate, setFromDate] = useState(moment().startOf("month").format("YYYY-MM-DD"));
//   const [toDate, setToDate] = useState(moment().format("YYYY-MM-DD"));
//   const [loading, setLoading] = useState(false);
//   const [showPaymentModal, setShowPaymentModal] = useState(false);

//   useEffect(() => {
//     const fetchSuppliers = async () => {
//       // ✅ ONLY FETCH SUPPLIERS
//       const res = await apiService.getAll(`${config.GETALLCOMPANIES}?companyType=SUPPLIER&parentCompanyId=${user.cid}`);
//       const formatted = res.map(s => ({ id: s.companyId, name: s.companyName }));
//       setSuppliers(formatted);
//     };
//     if (user?.cid) fetchSuppliers();
//   }, [user?.cid]);

//   const fetchStatement = async () => {
//     if (!selectedRefId) return alert("Please select a Supplier");
//     setLoading(true);
//     try {
//       const res = await apiService.getAll(`${config.GETSTATEMENT}/${selectedRefId}?fromDate=${fromDate}&toDate=${toDate}`);
//       setStatement(res);
//     } catch (error) {
//       console.error(error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const format = (val) => Number(val).toLocaleString("en-IN", { minimumFractionDigits: 2 });

//   return (
//     <div className="ledger-wrapper">
//       <Header User={user} />
//       <div className="p-2">
//         <AccountTabs pageName="SUPPLIERLEDGER" />
//       </div>
//       <div className="report-container">

//         <div className="report-header">
//           <div>
//             <h2 className="report-title">Supplier Ledger</h2>
//             <p className="company-id">Accounts Payable & Supplier History</p>
//           </div>
//         </div>

//         {/* Filter Bar */}
//         <div className="filter-bar no-print">
//           <div className="filter-group flex-grow">
//             <label>Select Supplier</label>
//             <select className="custom-input" value={selectedRefId} onChange={e => setSelectedRefId(e.target.value)}>
//               <option value="">-- Choose Supplier --</option>
//               {suppliers.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
//             </select>
//           </div>
//           <div className="filter-group">
//             <label>From Date</label>
//             <input type="date" className="custom-input" value={fromDate} onChange={e => setFromDate(e.target.value)} />
//           </div>
//           <div className="filter-group">
//             <label>To Date</label>
//             <input type="date" className="custom-input" value={toDate} onChange={e => setToDate(e.target.value)} />
//           </div>
//           <div className="filter-group">
//             <button className="search-button" onClick={fetchStatement} disabled={loading}>
//               {loading ? "Fetching..." : "View Ledger"}
//             </button>
//           </div>
//         </div>

//         {statement && (
//           <div className="statement-content">
//             <div className="statement-summary">
//               <div className="party-details">
//                 {/* <h4>{statement.partyName || suppliers.find(p => p.id === selectedRefId)?.name}</h4> */}
//                 <p>Period: <strong>{moment(fromDate).format("DD MMM YYYY")}</strong> - <strong>{moment(toDate).format("DD MMM YYYY")}</strong></p>
//               </div>

//               <div className="balance-section text-end">
//                 <div className="balance-label">Closing Balance</div>
//                 {/* <div className={`balance-amount ${statement.closingBalance >= 0 ? "text-red" : "text-green"}`}>
//                    ₹ {format(Math.abs(statement.closingBalance))}
//                    <span className="dr-cr-badge">{statement.closingBalance >= 0 ? "DR" : "CR"}</span>
//                 </div> */}
//                 <div
//                   className={`balance-amount ${statement.closingBalance >= 0 ? "text-green" : "text-red"
//                     }`}
//                 >
//                   ₹ {format(Math.abs(statement.closingBalance))}
//                   <span className="dr-cr-badge">
//                     {statement.closingBalance >= 0 ? "DR" : "CR"}
//                   </span>

//                   <div
//                     className={`balance-status ${statement.closingBalance >= 0
//                         ? "status-advance"
//                         : "status-payable"
//                       }`}
//                   >
//                     {statement.closingBalance >= 0
//                       ? "Advance Balance"
//                       : "Payable Due"}
//                   </div>
//                 </div>

//                 {/* Payment Button Enabled for Suppliers */}

//                 <button className="payment-btn no-print" onClick={() => setShowPaymentModal(true)}>
//                   Record Payment
//                 </button>

//               </div>
//             </div>

//             <div className="table-responsive">
//               <table className="ledger-table">
//                 <thead>
//                   <tr>
//                     <th>Date</th>
//                     <th>Description</th>
//                     <th>Voucher #</th>
//                     <th className="text-end">Debit (Dr)</th>
//                     <th className="text-end">Credit (Cr)</th>
//                     <th className="text-end">Balance</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   <tr className="opening-balance-row">
//                     <td colSpan="3"><strong>Opening Balance</strong></td>
//                     <td colSpan="2"></td>
//                     <td className="text-end font-bold">{format(statement.openingBalance)}</td>
//                   </tr>
//                   {statement.transactions.map((t, i) => (
//                     <tr key={i} className="transaction-row">
//                       <td className="date-col">{moment(t.date).format("DD/MM/YYYY")}</td>
//                       <td className="desc-col">{t.description}</td>
//                       <td>{t.invoiceNumber}</td>
//                       <td className="text-end text-red">{t.debit > 0 ? format(t.debit) : "-"}</td>
//                       <td className="text-end text-green">{t.credit > 0 ? format(t.credit) : "-"}</td>
//                       <td className="text-end font-bold text-dark">{format(t.runningBalance)}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//                 <tfoot>
//                   <tr className="footer-row">
//                     <td colSpan="3">Totals</td>
//                     <td className="text-end text-red">{format(statement.totalDebit)}</td>
//                     <td className="text-end text-green">{format(statement.totalCredit)}</td>
//                     <td className="text-end highlight-total">{format(statement.closingBalance)}</td>
//                   </tr>
//                 </tfoot>
//               </table>
//             </div>
//             <div className="action-footer no-print">
//               <button className="print-btn" onClick={() => window.print()}>Print Statement</button>
//             </div>
//           </div>
//         )}

//         {showPaymentModal && (
//           <SupplierPaymentModal
//             supplierId={selectedRefId}
//             supplierName={statement?.partyName}
//             balance={statement?.closingBalance || 0}
//             companyId={user.cid}
//             onClose={() => setShowPaymentModal(false)}
//             onSuccess={fetchStatement}
//           />
//         )}
//       </div>

//       <style jsx>{`
//         /* Reuse the EXACT CSS from previous answer here */
//         .ledger-wrapper { padding: 30px; background-color: #f4f7f6; min-height: 100vh; font-family: 'Segoe UI', sans-serif; }
//         .report-container { background: white; border-radius: 8px; border-top: 5px solid #0056b3; box-shadow: 0 4px 15px rgba(0,0,0,0.05); max-width: 1100px; margin: 0 auto; overflow: hidden; }
//         .report-header { background: #0056b3; color: white; padding: 20px 30px; }
//         .report-title { font-size: 24px; margin: 0; font-weight: 600; color: #fff; }
//         .company-id { font-size: 13px; opacity: 0.8; margin-top: 5px; }
//         .filter-bar { padding: 20px 30px; background: #f8f9fa; display: flex; gap: 15px; align-items: flex-end; border-bottom: 1px solid #e9ecef; }
//         .filter-group { display: flex; flex-direction: column; }
//         .filter-group.flex-grow { flex: 1; }
//         .filter-group label { font-size: 12px; font-weight: 600; color: #666; margin-bottom: 5px; text-transform: uppercase; }
//         .custom-input { padding: 8px 12px; border: 1px solid #ced4da; border-radius: 4px; font-size: 14px; outline: none; }
//         .search-button { padding: 9px 20px; background: #0056b3; color: white; border: none; border-radius: 4px; font-weight: 600; cursor: pointer; text-transform: uppercase; font-size: 13px; }
//         .statement-content { padding: 30px; }
//         .statement-summary { display: flex; justify-content: space-between; border-bottom: 2px solid #eee; padding-bottom: 20px; margin-bottom: 20px; }
//         .balance-amount { font-size: 28px; font-weight: 700; }
//         .text-red { color: #dc3545; } .text-green { color: #28a745; }
//         .ledger-table { width: 100%; border-collapse: collapse; font-size: 14px; }
//         .ledger-table th { background: #f1f3f5; padding: 12px; border-bottom: 2px solid #ddd; text-align: left; font-size: 12px; text-transform: uppercase; color: #555; }
//         .ledger-table td { padding: 10px; border-bottom: 1px solid #eee; color: #444; }
//         .text-end { text-align: right; }
//         .font-bold { font-weight: 700; }
//         .footer-row td { background: #eee; font-weight: 700; border-top: 2px solid #ddd; }
//         .payment-btn { margin-top: 10px; background: #28a745; color: white; border: none; padding: 6px 12px; font-size: 12px; border-radius: 4px; cursor: pointer; }
//         .print-btn { background: #fff; border: 1px solid #ccc; padding: 8px 16px; border-radius: 4px; cursor: pointer; font-weight: 600; }
//         .balance-status {
//   margin-top: 4px;
//   font-size: 12px;
//   font-weight: 600;
//   display: inline-block;
//   padding: 2px 8px;
//   border-radius: 12px;
// }

// .status-advance {
//   background-color: #e6f4ea;
//   color: #1e7e34;
// }

// .status-payable {
//   background-color: #fdecea;
//   color: #b02a37;
// }

// .dr-cr-badge {
//   margin-left: 8px;
//   font-size: 12px;
//   font-weight: 700;
// }

//         @media print { .no-print { display: none; } .report-container { box-shadow: none; border: none; } }
//       `}</style>
//     </div>
//   );
// };
// export default SupplierLedger;


import React, { useState, useEffect } from "react";
import apiService from "../../Common/Configurations/APIService";
import config from "../../Common/Configurations/APIConfig";
import { useAuth } from "../../Common/Configurations/AuthContext";
import moment from "moment";
import SupplierPaymentModal from "./SupplierPaymentModal";
import Header from "../../Common/Layout/Header";
import AccountTabs from "../AllTabs/AccountTabs";

const SupplierLedger = () => {
  const { user } = useAuth();
  const [statement, setStatement] = useState(null);
  const [suppliers, setSuppliers] = useState([]);
  const [selectedRefId, setSelectedRefId] = useState("");
  const [fromDate, setFromDate] = useState(moment().startOf("month").format("YYYY-MM-DD"));
  const [toDate, setToDate] = useState(moment().format("YYYY-MM-DD"));
  const [loading, setLoading] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);

  useEffect(() => {
    const fetchSuppliers = async () => {
      const res = await apiService.getAll(`${config.GETALLCOMPANIES}?companyType=SUPPLIER&parentCompanyId=${user.cid}`);
      const formatted = res.map(s => ({ id: s.companyId, name: s.companyName }));
      setSuppliers(formatted);
    };
    if (user?.cid) fetchSuppliers();
  }, [user?.cid]);

  const fetchStatement = async () => {
    if (!selectedRefId) return alert("Please select a Supplier");
    setLoading(true);
    try {
      const res = await apiService.getAll(`${config.GETSTATEMENT}/${selectedRefId}?fromDate=${fromDate}&toDate=${toDate}`);
      setStatement(res);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const format = (val) => Number(val).toLocaleString("en-IN", { minimumFractionDigits: 2 });

  return (
    <div id="layout-wrapper">
       <Header User={user} activeSection="accounts" />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="col-xl-12">
              <div className="card shadow-sm">
                {/* 1. TABS SECTION */}
                <div className="p-2">
                  <AccountTabs pageName="SUPPLIERLEDGER" />
                </div>

                <div className="card-body p-0">
                  <div className="report-container">
                    {/* Header Section with Blue Background */}
                    <div className="report-header">
                      <div className="d-flex justify-content-between align-items-center">
                        <div>
                          <h2 className="report-title">Supplier Ledger</h2>
                          <p className="company-id">Accounts Payable & Supplier History</p>
                        </div>
                      </div>

                      {/* Filter Bar integrated inside Header for better look */}
                      <div className="filter-bar no-print mt-3">
                        <div className="filter-group flex-grow">
                          <label>Select Supplier</label>
                          <select className="custom-input" value={selectedRefId} onChange={e => setSelectedRefId(e.target.value)}>
                            <option value="">-- Choose Supplier --</option>
                            {suppliers.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
                          </select>
                        </div>
                        <div className="filter-group">
                          <label>From Date</label>
                          <input type="date" className="custom-input" value={fromDate} onChange={e => setFromDate(e.target.value)} />
                        </div>
                        <div className="filter-group">
                          <label>To Date</label>
                          <input type="date" className="custom-input" value={toDate} onChange={e => setToDate(e.target.value)} />
                        </div>
                        <div className="filter-group">
                          <button className="search-button" onClick={fetchStatement} disabled={loading}>
                            {loading ? "Fetching..." : "View Ledger"}
                          </button>
                        </div>
                      </div>
                    </div>

                    {statement && (
                      <div className="statement-content">
                        <div className="statement-summary">
                          <div className="party-details">
                            {/* <h4 className="fw-bold">{statement.partyName}</h4> */}
                            <p>Period: <strong>{moment(fromDate).format("DD MMM YYYY")}</strong> - <strong>{moment(toDate).format("DD MMM YYYY")}</strong></p>
                          </div>

                          <div className="balance-section text-end">
                            <div className="balance-label">Closing Balance</div>
                            <div className={`balance-amount ${statement.closingBalance >= 0 ? "text-green" : "text-red"}`}>
                              INR {format(Math.abs(statement.closingBalance))}
                              <span className="dr-cr-badge">
                                {statement.closingBalance >= 0 ? "DR" : "CR"}
                              </span>
                            </div>
                            
                            <div className={`balance-status ${statement.closingBalance >= 0 ? "status-advance" : "status-payable"}`}>
                              {statement.closingBalance >= 0 ? "Advance Balance" : "Payable Due"}
                            </div>

                            <div className="mt-3">
                                <button className="payment-btn no-print me-2" onClick={() => setShowPaymentModal(true)}>
                                    Record Payment
                                </button>
                                {/* <button className="print-btn no-print" onClick={() => window.print()}>
                                    Print
                                </button> */}
                            </div>
                          </div>
                        </div>

                        <div className="table-responsive table-card">
                          <table className="ledger-table table align-middle">
                            <thead>
                              <tr>
                                <th>Date</th>
                                <th>Description</th>
                                <th>Voucher #</th>
                                <th className="text-end">Debit (Dr)</th>
                                <th className="text-end">Credit (Cr)</th>
                                <th className="text-end">Balance</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr className="opening-balance-row">
                                <td colSpan="3"><strong>Opening Balance</strong></td>
                                <td colSpan="2"></td>
                                <td className="text-end font-bold">{format(statement.openingBalance)}</td>
                              </tr>
                              {statement.transactions.map((t, i) => (
                                <tr key={i} className="transaction-row">
                                  <td className="date-col">{moment(t.date).format("DD/MM/YYYY")}</td>
                                  <td className="desc-col">{t.description}</td>
                                  <td>{t.invoiceNumber}</td>
                                  <td className="text-end text-red">{t.debit > 0 ? format(t.debit) : "-"}</td>
                                  <td className="text-end text-green">{t.credit > 0 ? format(t.credit) : "-"}</td>
                                  <td className="text-end font-bold text-dark">{format(t.runningBalance)}</td>
                                </tr>
                              ))}
                            </tbody>
                            <tfoot>
                              <tr className="footer-row">
                                <td colSpan="3">Totals</td>
                                <td className="text-end text-red">{format(statement.totalDebit)}</td>
                                <td className="text-end text-green">{format(statement.totalCredit)}</td>
                                <td className="text-end highlight-total">{format(statement.closingBalance)}</td>
                              </tr>
                            </tfoot>
                          </table>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showPaymentModal && (
        <SupplierPaymentModal
          supplierId={selectedRefId}
          supplierName={statement?.partyName}
          balance={statement?.closingBalance || 0}
          companyId={user.cid}
          onClose={() => setShowPaymentModal(false)}
          onSuccess={fetchStatement}
        />
      )}

      <style jsx>{`
        .report-container { background: white; border-radius: 8px; overflow: hidden; }
        .report-header { background: #0056b3; color: white; padding: 10px 10px; }
        .report-title { font-size: 24px; margin: 0; font-weight: 700; color: #fff; }
        .company-id { font-size: 13px; opacity: 0.9; margin-top: 5px; margin-bottom: 0; }
        
        /* Filter Bar inside Header */
        .filter-bar {
  background: rgba(255,255,255,0.1);
  padding: 15px;
  border-radius: 8px;
  display: flex;
  gap: 15px;
  align-items: flex-end;
  width: 75%;   /* adjust as needed */
}

        .filter-group { display: flex; flex-direction: column; }
        .filter-group label { font-size: 11px; font-weight: 700; color: #fff; margin-bottom: 5px; text-transform: uppercase; }
        .filter-group.flex-grow { flex: 1; }
        .custom-input { padding: 8px 12px; border: 1px solid transparent; border-radius: 4px; font-size: 14px; outline: none; background: #fff; color: #333; }
        .search-button { padding: 9px 20px; background: #fff; color: #0056b3; border: none; border-radius: 4px; font-weight: 700; cursor: pointer; text-transform: uppercase; font-size: 12px; transition: 0.3s; }
        .search-button:hover { background: #eef2f6; }

        .statement-content { padding: 30px; }
        .statement-summary { display: flex; justify-content: space-between; border-bottom: 2px solid #eee; padding-bottom: 20px; margin-bottom: 20px; }
        
        /* Fixed Colors */
        .balance-amount { font-size: 30px; font-weight: 800; }
        .text-red { color: #dc3545 !important; } 
        .text-green { color: #28a745 !important; }
        
        .balance-status { margin-top: 4px; font-size: 12px; font-weight: 700; display: inline-block; padding: 3px 12px; border-radius: 20px; }
        .status-advance { background-color: #e6f4ea; color: #1e7e34; }
        .status-payable { background-color: #fdecea; color: #b02a37; }

        .ledger-table { width: 100%; border-collapse: collapse; }
        .ledger-table th { background: #f8f9fa; padding: 12px; border-bottom: 2px solid #ddd; text-align: left; font-size: 11px; text-transform: uppercase; color: #555; }
        .ledger-table td { padding: 12px 10px; border-bottom: 1px solid #eee; font-size: 14px; }
        
        .payment-btn { background: #28a745; color: white; border: none; padding: 8px 16px; font-size: 12px; border-radius: 4px; cursor: pointer; font-weight: 700; }
        .print-btn { background: #fff; border: 1px solid #ccc; padding: 8px 16px; border-radius: 4px; cursor: pointer; font-weight: 700; color: #666; }
        
        .highlight-total { font-size: 16px; font-weight: 800; color: #0056b3; }
        .dr-cr-badge { margin-left: 8px; font-size: 14px; opacity: 0.7; }

        @media print { .no-print { display: none; } .card { border: none; } .main-content { padding: 0; } }
      `}</style>
    </div>
  );
};
export default SupplierLedger;